import { selectWarehouse } from '../Warehouses/warehousesSlice'
import useTranslation from 'hooks/useTranslation'
import Submit from 'components/inputs/Submit'
import Warehouse from 'components/Warehouse'
import { useSelector } from 'react-redux'

const Beginning = ({ id, name, isLoading, next }) => {
  const { doorState } = useSelector(state => selectWarehouse(state, id))

  const { t } = useTranslation('slides')
  const desc = t('openedMagDescArray')

  return (
    <>
      <i className='icon icon--logo s24' />
      <div className='slide__title center'>
        <div className='--secFont'>{t('congratulations')}</div>
        <div>{t('youOpenedYourMag')}</div>
      </div>

      <div className='fireworks'>
        <div />
        <div />
      </div>

      <Warehouse
        door={doorState.door}
        lock={doorState.lock}
        number={name}
        showShadow
      />
      <div className='slide__desc'>
        {Array.isArray(desc)
          ? desc.map((d, i) => <div key={i}>{d}</div>)
          : desc}
      </div>
      <Submit
        isLoading={isLoading}
        block={isLoading}
        text={t('letsStart')}
        action={next} />
    </>
  )
}

export default Beginning